export default __webpack_public_path__ + "static/media/eventDashboard_etc.d909448b.svg";